<div class="flex flex-col mb-20 w-full md:px-[3.5rem]">
    <div id="item-list-container" class="container mx-auto mt-6 ">

        <div
            class="flex flex-col lg:flex-row justify-between mx-4 sm:mx-0 font-noto-serif text-[var(--dark-teal)] text-3xl font-bold">
            Items
        </div>

        <div class="card flex justify-start">
            <p-breadcrumb [model]="itemsBreadcrumb" class="text-[14px] font-mulish text-gray-700"></p-breadcrumb>
        </div>

        <div class="flex flex-col xl:flex-row justify-between items-end mb-3 mx-4 sm:mx-0">

            <div class="flex flex-wrap lg:flex-nowrap gap-2 w-full items-end">

                <!-- Categories: Row 1 on mobile (full width), between Filter and Sort on desktop -->
                <div class="flex w-full lg:w-auto order-1 lg:order-2">
                    <p-multiSelect #categoryFilter [options]="subCategories()" optionLabel="name"
                        [(ngModel)]="selectedSubCategories" optionValue="code" (onChange)="subCategoryChanged($event)"
                        placeholder="Categories" display="chip" class="text-xs w-full lg:w-auto h-[35px]">
                    </p-multiSelect>
                </div>

                <!-- Filter button: Row 2 on mobile, first on desktop -->
                <button pButton type="button" icon="pi pi-filter-fill" label="Filter"
                    class="h-9 font-extrabold rounded-xl px-5 w-auto order-2 lg:order-1"
                    (click)="filterDialogVisible = true">
                </button>

                <!-- Sort + Clear: Row 2 on mobile, after Categories on desktop -->
                <div class="flex flex-row gap-2 items-end order-3 lg:order-3">
                    <p-select [options]="sortFilters" [(ngModel)]="selectedSort" placeholder="Sort by"
                        class="text-gray-400 flex-1 lg:flex-none w-auto" (onChange)="onSortChange($event)">
                    </p-select>

                    <div [style]="{ 'height': '35px' }" (click)="clearFilters()" class=" flex items-center">

                        <fa-icon [icon]="faTrash" class="cursor-pointer text-lg text-gray-500 ml-6">
                        </fa-icon>
                    </div>
                </div>

            </div>

            <div class="card justify-center hidden xl:flex lg:mt-4">
                <p-selectbutton [options]="this.itemListOptions" [(ngModel)]="viewMode" optionLabel="label"
                    optionValue="value" allowEmpty="false" class="custom-p-selectbutton h-[37px] border-none ">
                    <ng-template #item let-item class="">
                        <p-button p-button  [text]="item.value!=viewMode" class="custom-p-button">
                            <fa-icon class="text-[12px]"
                                [icon]="item.value == 'image' ? icons.faImage : icons.faList"></fa-icon> <span
                                class="whitespace-nowrap text-[12px]">{{item.label}}</span>
                        </p-button>
                    </ng-template>
                </p-selectbutton>
            </div>

        </div>


        <ng-container *ngIf="!pageIsLoaded() ; else content">
            <div class="flex items-center justify-center min-h-[300px]">
                <p-progress-spinner ariaLabel="loading" />
            </div>
        </ng-container>


        <ng-template #content>


            <div *ngIf="((itemList !== undefined) && (itemList !== null) && (itemList.length > 0))">

                <div class="container mx-auto pt-8">
                    <app-main-items [items]="itemList" [viewMode]="viewMode" [category]="selectedCategory()"
                        [isAuthenticated]="isAuthenticated"></app-main-items>

                    <p-paginator [rows]="filters().per" [totalRecords]="totalItems"
                        (onPageChange)="onPageChange($event)" [first]="firstSignal()"
                        [rowsPerPageOptions]="rowsPerPageOptions" styleClass="mt-7">
                    </p-paginator>
                </div>
            </div>

            <div *ngIf="((itemList === undefined) || (itemList === null) || (itemList.length === 0))"
                id="item-search-container" class="container mx-auto lg:px-20 min-h-auto">
                <div class="flex flex-col items-center justify-center text-center mt-2 px-2">
                        <div class="text-[150px] text-custom-blue mb-4 relative inline-block">
            <fa-icon [icon]="faMagnifyingGlass"></fa-icon>

            <fa-icon
                [icon]="faX"
                class="absolute 
                    top-[42%] left-[42%]
                    -translate-x-1/2 -translate-y-1/2
                    text-3xl text-custom-blue font-bold">
            </fa-icon>
        </div>
                            <p class="text-xl  lg:text-2xl font-semibold mb-2">
                        We didn’t find any results
                    </p>
                </div>
            </div>
        </ng-template>
    </div>
</div>
<p-dialog [(visible)]="filterDialogVisible" [modal]="true" [dismissableMask]="true" [closeOnEscape]="true"
    [closable]="true" [style]="{ width: '90vw', maxWidth: '32rem' }" styleClass="rounded-2xl">

    <ng-template pTemplate="header">
        <div class="flex items-center justify-end w-full pr-3">
            <button type="button" class="p-dialog-header-icon p-dialog-header-clear p-link"
                (click)="resetModalFiltersOnly()" pTooltip="Clear filters" tooltipPosition="bottom">
                <span class="pi pi-trash"></span>
            </button>
        </div>
    </ng-template>

    <div class="space-y-6">

        <!-- SECTION 1: PRICE RANGE -->
        <section *ngIf="prices().length > 0" class="space-y-3">
            <h3 class="text-lg font-semibold mb-4">Price Range</h3>

            <!-- Slider -->
            <p-slider [(ngModel)]="priceRangeIndexes" [range]="true" [step]="1" [min]="0" [max]="prices().length - 1"
                (onChange)="handleSliderChange($event)" (onSlideEnd)="handleSlideEnd($event)">
            </p-slider>

            <!-- Lower / upper text boxes -->
            <div class="flex items-center justify-center gap-2 mt-2">
                <input pInputText class="w-24 text-right" [readonly]="true" [value]="selectedLowerBoundSignal()">
                <span class="mx-1">–</span>
                <input pInputText class="w-24 text-left" [readonly]="true" [value]="selectedUpperBoundSignal()">
            </div>
        </section>

        <!-- SECTION 2: LOCATIONS -->
        <section *ngIf="locations().length > 0" class="space-y-2">
            <h3 class="text-lg font-semibold">Locations</h3>

            <div class="flex flex-col gap-1">
                <div *ngFor="let loc of locations(); let i = index" class="flex items-center gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectedLocations[i]"
                        (onChange)="onAnyFilterChangedExceptPriceRange()">
                    </p-checkbox>
                    <span>{{ loc.name }}</span>
                </div>
            </div>
        </section>

        <!-- SECTION 3: ADDITIONAL OPTIONS -->
        <section *ngIf="buyNow() || onlineNow() || closingSoon() || newItems()" class="space-y-2">
            <h3 class="text-lg font-semibold">Additional Options</h3>

            <div class="flex flex-col gap-1">

                <div *ngIf="buyNow()" class="flex items-center gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectedBuyNow"
                        (onChange)="onAnyFilterChangedExceptPriceRange()">
                    </p-checkbox>
                    <span>{{ buyNow()!.name }}</span>
                </div>

                <div *ngIf="onlineNow()" class="flex items-center gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectedOnlineNow"
                        (onChange)="onAnyFilterChangedExceptPriceRange()">
                    </p-checkbox>
                    <span>{{ onlineNow()!.name }}</span>
                </div>

                <div *ngIf="closingSoon()" class="flex items-center gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectedClosingSoon"
                        (onChange)="onAnyFilterChangedExceptPriceRange()">
                    </p-checkbox>
                    <span>{{ closingSoon()!.name }}</span>
                </div>

                <div *ngIf="newItems()" class="flex items-center gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectedNewItems"
                        (onChange)="onAnyFilterChangedExceptPriceRange()">
                    </p-checkbox>
                    <span>{{ newItems()!.name }}</span>
                </div>

            </div>
        </section>

    </div>
</p-dialog>
